import background from "../../public/background.jpg";
import logo from "../../public/logo.png";
import "./auth-shell.css";

export function AuthShell({ alignContent = "center", children, footer, subtitle, title, wide = false }) {
  const contentClassName = ["or-auth-layout__content", alignContent === "start" ? "or-auth-layout__content--start" : ""]
    .filter(Boolean)
    .join(" ");

  const wrapperClassName = ["or-auth-layout__form-wrapper", wide ? "or-auth-layout__form-wrapper--wide" : ""]
    .filter(Boolean)
    .join(" ");

  const sectionClassName = [
    "or-auth-layout__form-section",
    alignContent === "start" ? "or-auth-layout__form-section--start" : "",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="or-auth-page">
      <main className="or-auth-layout">
        <section aria-hidden="true" className="or-auth-layout__visual-section">
          <div className="or-auth-visual">
            <img alt="Openreferences" className="or-auth-layout__logo" src={logo} />
            <img alt="Equipo colaborando" className="or-auth-visual__image" src={background} />

            <div className="or-auth-floating-card or-auth-floating-card--yellow or-auth-floating-card--top">
              <span className="or-auth-floating-card__title">Revisión de tareas</span>
              <span className="or-auth-floating-card__time">09:30am-10:00am</span>
            </div>

            <div className="or-auth-floating-card or-auth-floating-card--dark or-auth-floating-card--middle">
              <span className="or-auth-floating-card__time">09:30am-10:00am</span>
            </div>

            <div className="or-auth-floating-card or-auth-floating-card--white or-auth-floating-card--bottom">
              <span className="or-auth-floating-card__title">Reunión diaria</span>
              <span className="or-auth-floating-card__time">12:00pm-01:00pm</span>
              <div className="or-auth-avatar-group">
                <span className="or-auth-avatar-group__item">A</span>
                <span className="or-auth-avatar-group__item">B</span>
                <span className="or-auth-avatar-group__item">C</span>
                <span className="or-auth-avatar-group__item">D</span>
              </div>
            </div>

            <div className="or-auth-calendar-strip">
              <div className="or-auth-calendar-strip__header">
                <span>Dom</span>
                <span>Lun</span>
                <span>Mar</span>
                <span>Mié</span>
                <span>Jue</span>
                <span>Vie</span>
                <span>Sáb</span>
              </div>
              <div className="or-auth-calendar-strip__body">
                <span>22</span>
                <span>23</span>
                <span>24</span>
                <span className="or-auth-calendar-strip__date--active">25</span>
                <span>26</span>
                <span>27</span>
                <span>28</span>
              </div>
            </div>

            <div className="or-auth-floating-avatar or-auth-floating-avatar--1">A</div>
            <div className="or-auth-floating-avatar or-auth-floating-avatar--2">B</div>
            <div className="or-auth-floating-avatar or-auth-floating-avatar--3">C</div>
          </div>
        </section>

        <section className={sectionClassName}>
          <div className={wrapperClassName}>
            <img alt="Openreferences" className="or-auth-logo" src={logo} />
            <div className={contentClassName}>
              <div className="or-auth-layout__intro">
                {title ? <h1 className="or-auth-layout__title">{title}</h1> : null}
                {subtitle ? <p className="or-auth-layout__subtitle">{subtitle}</p> : null}
              </div>
              {children}
            </div>

            {footer ? <footer className="or-auth-layout__footer">{footer}</footer> : null}
          </div>
        </section>
      </main>
    </div>
  );
}
